import styled from 'styled-components';

export const Divider = styled.div`
  position: relative;
  height: 150px;
  background: linear-gradient(to bottom, white, #f8f8f8);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
    height: 1px;
    background: linear-gradient(
      to right,
      transparent,
      ${props => props.theme.colors.primary}33,
      ${props => props.theme.colors.primary},
      ${props => props.theme.colors.primary}33,
      transparent
    );
  }

  &::after {
    content: '✝';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: ${props => props.background || '#f8f8f8'};
    padding: 0 2rem;
    color: ${props => props.theme.colors.primary};
    font-size: 2rem;
  }
`;

export const DarkDivider = styled(Divider)`
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.9));
  
  &::before {
    background: linear-gradient(
      to right,
      transparent,
      ${props => props.theme.colors.primary}22,
      ${props => props.theme.colors.primary}88,
      ${props => props.theme.colors.primary}22,
      transparent
    );
  }

  &::after {
    background: transparent;
    color: ${props => props.theme.colors.primary};
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  }
`;

export const FooterDivider = styled(Divider)`
  margin-bottom: -50px;
  z-index: 2;
  height: 100px;
  
  &::before {
    width: 40%;
    background: linear-gradient(
      to right,
      transparent,
      ${props => props.theme.colors.primary}22,
      ${props => props.theme.colors.primary}66,
      ${props => props.theme.colors.primary}22,
      transparent
    );
  }

  &::after {
    font-size: 1.8rem;
    background: white;
    padding: 0 2rem;
  }
`; 